import { useParamsContext } from '../../contexts/ParamsContext';
import GruposClientesForm from './form/Form';
import GruposClientesList from './list/List';
import { GruposClientesProvider } from './Context';

function GruposClientes() {
    const { action } = useParamsContext();

    switch (action) {
        case 'edit':
        case 'add': {
            return <GruposClientesForm />;
        }
        case 'list':
        default:
            return <GruposClientesList />;
    }
}

export default function GruposClientesRoute() {
    return (
        <GruposClientesProvider>
            <GruposClientes />
        </GruposClientesProvider>
    );
}
